import SeasonSelect from "@/components/SeasonSelect.vue";
import DepartmentSelect from "@/components/DepartmentSelect.vue";
import TaskTypeSelect from "@/components/TaskTypeSelect.vue";
import AvailableSelect from "@/components/AvailableSelect.vue";
import { ElMessageBox, ElMessage } from "element-plus";
import { TaskPlanTable, TaskPlanHistoryTable } from "../data/TaskMake";
import EmployeeSelect from "@/components/EmployeeSelect.vue";


import { post, uploadPost, postByFileDevice } from "../utils/request";
import { getSeason, getTaskTypeName } from "../utils/utilApi";
import moment from "moment";

import { MAX_UPLOAD_FILE_SIZE, FILE_SPACE_BASE_DIR } from "../utils/utilData";

export default {
  components: {
    SeasonSelect,
    DepartmentSelect,
    TaskTypeSelect,
    AvailableSelect,
    EmployeeSelect
  },
  data() {
    return {
      activeTab: "first",
      activeCollapse: ["1", "2"],
      activeCollapse2: ["1", "2"],
      TaskPlanTable: [],
      TaskPlanHistoryTable: [],
      taskSelect: [],
      // 是否禁用组件, true为禁用, false为不禁用
      disableComp: {
        title: false,
        departmentSelect: false,
        taskForm1: false,
        submitBtn: false,
      },
      // 是否显示组件
      showableComp: {
        departmentSelect: false,
        addTaskDialog: false,
        taskForm2: false,
        btn1: false,
        btn2: false,
      },
      behaviorForm: {
        behaviorId: "",
        year: String(new Date().getFullYear()),
        season: getSeason(),
        departmentId: JSON.parse(sessionStorage.getItem('departmentInfo')).departmentId,
        departmentName: JSON.parse(sessionStorage.getItem('departmentInfo')).departmentName,
        title: "",
        taskList: [],
        summary: "",
        remarks: "",
        taskNum: " ",
        taskCompleteNum: " ",
        taskInCompleteNum: " ",
        appendixList: [],
        subjectType: "用户",
      },
      TaskForm: {
        taskId: "",
        taskCategory: "",
        respPerson: JSON.parse(sessionStorage.getItem("userInfo")).userId,
        // respPerson: "",
        detail: "",
        criterion: "",
        dateLimit: "",
        taskType: "",
        score: "",
        remarks: "",
        accomplish: "",
        accomplishDate: "",
        accomplishTimeRatio: "",
        accomplishRatio: "",
        accomplishDetail: "",
      },
      appendixForm: {
        appendixId: "",
        appendixName: "",
        appendixURL: "",
      },
      behaviorList: [],
      file: "",
      weekSummaryList: [],
      curWeekSummary: "",
    };
  },
  name: "DepTaskMake",
  methods: {
    // 表格选择
    handleSelect(val, row) {
      // val是个数组，row是数组中的第一个对象
      this.taskSelect = val;
    },
    // 全选
    handleSelectAll(val) {
      this.taskSelect = val;
    },
    // 切换tab
    handleClick(tab, event) {
    },
    doCancelAddTask() {
      this.showableComp.addTaskDialog = false;
    },
    // 表格数据格式转换
    formatter(row, column) {
      if (column.property == "accomplish") {
        return row.accomplish == true ? "已完成" : "否";
      } else if (column.property == "taskType") {
        return getTaskTypeName(row.taskType);
      } else if (column.property == "respPerson") {
        return row.respPersonName;
      } else {
        return row[column.property];
      }
    },

    // 上传附件

    /**
     * @function POST /behavior/search/personal
     * @description 查找当前季度部门工作情况报告，（*如果没有工作报告只有分配的任务，则在后台自动创建一个工作报告，并返回id）
     * 
     * @param userId 用户ID
     * @param year 年份
     * @param season 季度
     * @param subjectType 主体类型
     * 
     * @returns R.success.code(200).message("查找成功").data("")
     * @returns data(behaviorId报告ID, title报告题目, summary工作小结, remarks需要其他科室配合事项, taskList任务集合, appendixList附件集合)
     * @returns R.message.code(204).message("尚未创建本季度任务计划")
     */
    searchBehaviorReport() {
      let behaviorForm = {
        year: this.behaviorForm.year,
        season: this.behaviorForm.season,
        userId: JSON.parse(sessionStorage.getItem("userInfo")).userId,
        subjectType: 1,
      };
      let data = JSON.stringify(behaviorForm);
      post('/behavior/search/personal', data).then((res) => {
        if (res.code == 200) {

          res = JSON.parse(res.data.report);
          if (res.submit == 1) {
            this.disableComp.submitBtn = true;
          }
          this.behaviorForm.behaviorId = res.behaviorId;
          this.behaviorForm.title = res.title;
          this.behaviorForm.summary = res.summary;
          this.behaviorForm.remarks = res.remarks;
          this.behaviorForm.taskList = res.taskList;
          this.behaviorForm.appendixList = res.appendixList;
          this.behaviorForm.state = res.state;
          // 做计算(任务数，已完成，未完成等)
          this.behaviorForm.taskNum = res.taskList.length;
          let complete = 0;
          for (let item in res.taskList) {
            if (item.complete == 1) {
              complete += 1;
            }
          }
          this.behaviorForm.taskCompleteNum = complete;
          this.behaviorForm.taskInCompleteNum = this.behaviorForm.taskNum - complete;

        } else if (res.code == 204) {
          ElMessageBox.alert('是否需要创建本季任务计划报告？', '提示', {
            confirmButtonText: '是',
            cancelButtonText: '否',
          })
            .then(() => {
              this.addBehavior();
            });
        }
      });
    },

    /**
     * @function POST /behavior/add/personal
     * @description 创建新的工作情况报告（*增加了新的参数）
     * 
     * @param departmentId 部门ID
     * @param createDate 创建时间
     * @param userId 用户ID
     * @param subjectType 1
     * @param year 年
     * @param season 季度
     * 
     * @returns R.success.code(200).message("创建任务计划成功").data("behaviorId");
     * @returns R.error.code(500).message("创建任务计划失败，请联系管理员");
     */
    addBehavior() {
      this.behaviorForm.behaviorDate = moment().format("YYYY-MM-DD");
      let data = {
        departmentId: this.behaviorForm.departmentId,
        createDate: this.behaviorForm.behaviorDate,
        userId: JSON.parse(sessionStorage.getItem("userInfo")).userId,
        subjectType: 1,
        season: this.behaviorForm.season,
        year: this.behaviorForm.year,
      };
      post('/behavior/add/personal', JSON.stringify(data)).then((res) => {
        this.behaviorForm.behaviorId = res.data.behaviorId;
      });
    },

    /**
     * @function POST /behavior/save
     * @description 提交/更新工作情况报告
     *
     * @param behaviorId 报告id
     * @param behaviorDate 提交时间
     * @param title 报告标题
     * @param remarks 需要统筹协调或其他科室配合事项（备注）
     * @param subject_type 报告主体类型。1为科室2为用户
     * 
     * @returns R.success.code(200).message("提交成功") ps：提交报告需要保存信息并与将报告与分管领导相关联（最后做这个功能，可能需要修改数据库设计）
     * @returns R.error.code(500).message("提交失败，请联系管理员")
     */
    saveBehavior() {
      this.behaviorForm.behaviorDate = moment().format("YYYY-MM-DD");
      let data = this.behaviorForm;
      post('/behavior/save', JSON.stringify(data)).then((res) => {
        console.log("提交成功");
      });
    },
    // 提交报告
    submitBehavior() {
      let data = { behaviorId: this.behaviorForm.behaviorId };
      post('/behavior/submit', JSON.stringify(data)).then((res) => {
        if (res.code == 200) {
          ElMessage.success("提交成功", {
            duration: 3 * 1000,
          });
        }
      });
    },
    /**
     * @function POST /behavior/update
     * @description 更新工作情况报告
     *
     * @param behaviorId 工作情况报告ID
     * @param summary 工作小结
     * @param remarks 需要统筹协调或其他科室配合事项（备注）
     * @param appendixList 附件集合
     * 
     * @returns R.success.code(200).message("更新成功")
     * @returns R.error.code(500).message("更新失败，请联系管理员")
     */
    updateBehavior() {
      let data = {
        behaviorId: this.behaviorForm.behaviorId,
        summary: this.behaviorForm.summary,
        remarks: this.behaviorForm.remarks,
        appendixList: this.behaviorForm.appendixList,
      }
      post('/behavior/update', data).then((res) => {
        console.log("更新成功");
      });
    },
    // 添加任务按钮
    showAddTaskForm() {
      // 重置TaskForm表单中的数据
      Object.assign(this.$data.TaskForm, this.$options.data().TaskForm);

      this.disableComp.taskForm1 = false;
      this.showableComp.addTaskDialog = true;
      this.showableComp.taskForm2 = false;
      this.showableComp.btn1 = false;
      this.showableComp.btn2 = true;
    },
    /**
     * @function POST /task/batch/search
     * 
     * @description 根据工作情况报告ID批量查找科室当前季度的任务
     * 
     * @param behaviorId 工作情况报告ID
     * 
     * @returns R.success.code(200).message("查找成功").data(taskList任务集合)
     * @returns R.message.code(204).message("尚未添加本季度任务")
     */
    searchDepTaskBatch() {
      let data = JSON.stringify({
        behaviorId: this.behaviorId,
      });
      post('/task/search/dep/batch', data).then((res) => {
        this.behaviorForm.taskList = JSON.parse(res.data.data);
      });
    },

    doEditHandler() {
      // 需要先选中一条任务
      if (this.taskSelect.length == 0) {
        this.$message({
          message: '请先选择一条任务',
          type: 'warning'
        });
      } else {
        this.TaskForm = this.taskSelect[0];
        // 控制渲染
        this.disableComp.taskForm1 = false;
        this.showableComp.addTaskDialog = true;
        this.showableComp.taskForm2 = false;
        this.showableComp.btn1 = true;
        this.showableComp.btn2 = false;

        // 属性名转换
        this.TaskForm.detail = this.taskSelect[0].taskDetail;
        this.TaskForm.criterion = this.taskSelect[0].evaCriterion;
        this.TaskForm.score = this.taskSelect[0].totalScore;
        this.TaskForm.dateLimit = this.taskSelect[0].endDate;
        this.TaskForm.taskCategory = this.taskSelect[0].categoryName;
      }
    },
    /**
     * @function POST /task/delete
     * 
     * @description 删除任务
     * 
     * @param taskIdArr[] 任务Id数组
     * 
     * @returns R.success.code(200).message("删除成功")
     * @returns R.error.code(500).message("删除失败，请联系管理员")
     */
    deleteTask() {
      if (this.taskSelect.length == 0) {
        this.$message({
          message: '请先选择一条任务',
          type: 'warning'
        });
      } else {
        let taskIdArr = [];
        for (let i = 0, len = this.taskSelect.length; i < len; i++) {
          taskIdArr.push(this.taskSelect[i].taskId);
        }
        post('/task/delete', JSON.stringify({ taskIdArr: taskIdArr })).then((res) => {
          // code=200，重新渲染表格
          if (res.code == 200) {
            for (let i = 0, len = this.behaviorForm.taskList.length; i < len; i++) {
              if (taskIdArr.indexOf(this.behaviorForm.taskList[i].taskId) > -1) {
                this.behaviorForm.taskList.splice(i, 1);
                i--;
              }
            }
          }
        });
      }
    },
    /**
     * @function POST /task/add
     * 
     * @description 添加任务
     * @param behaviorId 报告ID
     * @param taskCategory 任务分类
     * @param respPerson 责任人
     * @param detail 工作内容
     * @param criterion 标准要求
     * @param dateLimit 要求完成时限
     * @param taskType 任务类型
     * @param score 分值
     * @param remarks 备注
     * 
     * 
     * @returns R.success.code(200).message("任务添加成功").data("taskId")
     * @returns R.error.code(500).message("任务添加失败，请联系管理员")
     */
    addTask() {
      // 计算总分不允许超过100
      if (this.getTotalScore + parseInt(this.TaskForm.score) > 100) {
        ElMessage.error("总分超过了100分", {
          duration: 3 * 1000,
        });
        return;
      }
      // 如果还没有创建新的工作情况报告
      if (this.behaviorForm.behaviorId == "") {
        this.addBehavior();
      }
      let data = JSON.parse(JSON.stringify(this.TaskForm));
      data.behaviorId = this.behaviorForm.behaviorId;
      data.evaCriterion = this.TaskForm.criterion;
      post('/task/add', JSON.stringify(data)).then((res) => {
        // code=200，重新渲染表格
        // this.data.taskId = JSON.parse(res.data.data).taskId;
        data.taskId = res.data.taskId;
        delete data.behaviorId;
        // 属性名改变
        data.categoryName = data.taskCategory;
        data.taskDetail = data.detail;
        data.evaCriterion = data.criterion;
        data.totalScore = data.score;
        data.endDate = data.dateLimit;
        this.behaviorForm.taskList.push(data);
        // 重置表单
        // Object.assign(this.$data.TaskForm, this.$options.data().TaskForm);
      });

      this.showableComp.addTaskDialog = false;
    },
    handleOpen() { },
    handleBack() { },
    // 纪实按钮
    handleRecord(index, row) {
      this.disableComp.taskForm1 = true;
      this.showableComp.taskForm2 = true;
      this.showableComp.addTaskDialog = true;
      this.showableComp.btn1 = true;
      this.showableComp.btn2 = false;
      this.TaskForm = row;
      this.taskSelect = row;
      // 属性名转换
      this.TaskForm.detail = row.taskDetail;
      this.TaskForm.criterion = row.evaCriterion;
      this.TaskForm.score = row.totalScore;
      this.TaskForm.dateLimit = row.endDate;
      this.TaskForm.taskCategory = row.categoryName;
    },
    /**
     * @function POST /task/save
     * 
     * @description 修改保存一条任务信息
     * 
     * @param taskId 任务Id
     * @param taskCategory 任务分类
     * @param respPerson 责任人
     * @param detail 工作内容
     * @param criterion 标准要求
     * @param dateLimit 要求完成时限
     * @param taskType 任务类型
     * @param score 分值
     * @param remarks 备注
     * @param accomplish 是否完成
     * @param accomplishDate 完成时间
     * @param accomplishTimeRatio 完成时效
     * @param accomplishRatio 完成比例
     * @param accomplishDetail 完成情况
     * 
     * @returns R.success.code(200).message("保存成功")
     * @returns R.success.code(200).message("保存失败，请联系管理员")
     */
    saveRecord() {
      // console.log(this.taskSelect);
      // console.log(this.getTotalScore, this.taskSelect[0].totalScore, this.taskSelect[0].score);
      // // 计算总分不允许超过100
      // if (this.getTotalScore - parseInt(this.taskSelect[0].totalScore) + parseInt(this.taskSelect[0].score) > 100) {
      //   ElMessage.error("总分超过了100分", {
      //     duration: 3 * 1000,
      //   });
      //   return;
      // }
      this.showableComp.addTaskDialog = false;

      let data = this.TaskForm;
      post('/task/save', JSON.stringify(data)).then((res) => {
        for (let i = 0, len = this.behaviorForm.taskList.length; i < len; i++) {
          if (this.behaviorForm.taskList[i].taskId == data.taskId) {
            this.behaviorForm.taskList.splice(i, 1);
            break;
          }
        }
        this.behaviorForm.taskList.push(this.TaskForm);
      });
    },
    // 计算已有任务的总分
    // getTotalScore() {
    //   let res = 0;
    //   for (let i = 0; i < this.behaviorForm.taskList.length; i++) {
    //     res += this.behaviorForm.taskList[i].totalScore;
    //   }
    //   return res;
    // }
    // 自定义上传文件函数
    uploadFile(param) {
      let form = new FormData();
      form.append('file', param.file);
      form.append('behaviorId', this.behaviorForm.behaviorId);
      form.append('userId', JSON.parse(sessionStorage.getItem("userInfo")).userId);
      uploadPost('/appendix/upload', form).then(res => {
        this.behaviorForm.appendixList = [];
        // 上传成功后把文件信息push进附件数组中
        this.behaviorForm.appendixList.push(JSON.parse(res.data.appendix));
        this.$refs.uploadAppendix.clearFiles();
      })
    },
    getUploadFile(file, fileList) {
      let allowedExtention = ["pdf", "doc", "docx", "jpg", "jpeg", "png", "rar", "zip"];
      let fileExtention = file.name.substring(file.name.lastIndexOf(".") + 1);
      // 限制文件上传类型
      if (allowedExtention.indexOf(fileExtention) === -1) {
        ElMessage.error("该文件类型不允许上传", {
          duration: 3 * 1000,
        });
        this.behaviorForm.appendixList = [];
        return;
      }
      // 每次上传文件前都先将其清空
      this.behaviorForm.appendixList = [];
      // this.file = file.raw;
      // 文件上传不能大于10M
      if (file.size / 1024 / 1024 > MAX_UPLOAD_FILE_SIZE) {
        ElMessage.error("文件大小超过" + MAX_UPLOAD_FILE_SIZE + "M, 不予上传", {
          duration: 3 * 1000,
        });
        this.behaviorForm.appendixList = [];
        return;
      }
      // 每次上传就自动调用上传函数
      this.$refs.uploadAppendix.submit();
    },
    // 附件下载
    handlePreview(file) {
      var a = document.createElement("a");
      var event = new MouseEvent('click');
      a.download = file.name;
      a.href = FILE_SPACE_BASE_DIR + file.url;
      a.dispatchEvent(event);
    },
    // 附件删除
    handleRemove(file) {
      let data = {
        appendixId: file.appendixId,
        type: 1,
      }
      post('/appendix/delete', JSON.stringify(data)).then((res) => {
        if (res.code == 200) {
          this.behaviorForm.appendixList = [];
        }
      });
    },
    /**
     * @description 根据behaviorId导出文件
     * @function POST /behavior/export/personal
     * 
     * @param behaviorId 工作情况报告Id
     * 
     * @returns file 文件保存地址
     */
    exportBehavior() {
      postByFileDevice('/behavior/export/personal', this.behaviorForm.behaviorId).then((res) => {
        let file = res.data.data;
        var a = document.createElement("a");
        var event = new MouseEvent('click');
        a.download = "个人工作情况报告";
        let fp = '/home/fileSpace'
        // 截取字符串后返回
        a.href = FILE_SPACE_BASE_DIR + file.substring(fp.length, file.length);
        a.dispatchEvent(event);
      });
    },

    // 添加周记按钮
    addWeekSummary() {
      this.weekSummaryList.unshift(
        { timestamp: moment().format("YYYY-MM-DD"), }
      );
    },
    /**
     * @description 保存或插入小结
     * @function POST /summary/save
     * 
     * @param {int} id 小结编号，若有则更新，没有则插入
     * @param {int} year 年度
     * @param {String} season 季度，如“第一季度”
     * @param {int} userId 用户ID
     * @param {Date} timestamp 日期（2018-04-15）
     * @param {String} summary 小结内容
     * 
     * @returns id小结编号
     */
    saveSummary(index, activity) {
      let data = {
        id: activity.id,
        year: this.behaviorForm.year,
        season: this.behaviorForm.season,
        userId: JSON.parse(sessionStorage.getItem("userInfo")).userId,
        timestamp: activity.timestamp,
        summary: activity.summary,
      }
      post('/summary/save', JSON.stringify(data)).then((res) => {
        if (res.code == 200) {
          this.weekSummaryList[index].id = JSON.parse(res.data.data);
        }
      });
    },
    /**
     * @description 删除小结
     * @function POST /summary/delete
     * 
     * @param {int} id 小结id
     * 
     * @returns 成功或失败信息
     */
    deleteSummary(index, activity) {
      if (!('id' in activity)) {
        this.weekSummaryList.splice(index, 1);
        return;
      }
      let data = {
        id: activity.id,
      };
      post('/summary/delete', JSON.stringify(data)).then((res) => {
        if (res.code == 200) {
          this.weekSummaryList.splice(index, 1);
        }
      });
    },
    /**
     * @description 查询小结
     * @function POST /summary/search
     * 
     * @param {int} year 年度
     * @param {String} season 季度，如“第一季度”
     * @param {int} userId 用户ID
     * 
     * @returns 返回值为data，每一项包括id编号、timestamp日期（2018-04-15）、summary小结、userId用户Id、year年度、season季度（如“第一季度”）
     */
    searchSummary() {
      let data = {
        year: this.behaviorForm.year,
        season: this.behaviorForm.season,
        userId: JSON.parse(sessionStorage.getItem("userInfo")).userId,
      }
      post('/summary/search', JSON.stringify(data)).then((res) => {
        if (res.code == 200) {
          this.weekSummaryList = JSON.parse(res.data.data);
        }
      });
    }
  },
  watch: {
    activeTab() {
      if (this.activeTab == "second") {
        this.searchBehaviorReport();
        this.behaviorList = [];
        this.behaviorList.push(this.behaviorForm);
      } else if (this.activeTab == "third") {
        this.searchSummary();
      }
    },
    "behaviorForm.year"() {
      if (this.activeTab != "third") {
        this.searchBehaviorReport();
      }
    },
    "behaviorForm.season"() {
      if (this.activeTab != "third") {
        this.searchBehaviorReport();
      }
    },
  },
  computed: {
    getTotalScore() {
      let res = 0;
      for (let i = 0; i < this.behaviorForm.taskList.length; i++) {
        res += this.behaviorForm.taskList[i].totalScore;
      }
      return res;
    }
  },
  created() {
    this.TaskPlanTable = TaskPlanTable;
    this.TaskPlanHistoryTable = TaskPlanHistoryTable;
    this.searchBehaviorReport();
  },
};